import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';

const PageTransition = () => {
  const { isMobile } = useCheckMobileScreen();

  // return <PageTransitionMobile />

  if(isMobile){
    return <PageTransitionMobile />
  }else{
    return null;
  }
}

const PageTransitionMobile = () => {
    const location = useLocation();

    const { isMobile } = useCheckMobileScreen();

    const pageRoutesToHaveBg = [
      '/more',
      '/my-account',
      '/my-payments',
      '/my-cards',
      '/terms-and-conditions',
      '/personal-info',
      '/password-management',
      '/delete-account',
      '/transaction-history',
      '/transaction-detail',
      '/payment-method',
      '/support',
      '/support-assistant',
      '/ooredoo-pedia',

      '/home/index',
      '/nojoom',

      '/verification-otp',
      '/verification-paci',
      '/verification-confirmation',
      '/choose',
      '/call-details',
      '/verification'
    ]
    const applyBg = pageRoutesToHaveBg.includes(location.pathname);

    if(isMobile && applyBg){
      if(document){
        document.body.classList.add('sprint16bg');
      }
    }else{
      if(document){
        document.body.classList.remove('sprint16bg');
      }
    }


    useEffect(() => {
        if(sessionStorage.getItem('location-next')){
          sessionStorage.setItem('location-pre', sessionStorage.getItem('location-next'));
        }

        sessionStorage.setItem('location-next', JSON.stringify(location));

        const isBothLocationSame = sessionStorage.getItem('location-pre') === sessionStorage.getItem('location-next');

        const el = document.getElementsByClassName('body_container')[0];

        if(el){
          el.classList.add('slidein-transition');
        }

        const ell = document.getElementsByClassName('slidein-transition')[0];

        const elll = document.getElementsByClassName('slidein-from-left')[0];

        if(!elll){
          if(ell){
            if(isBothLocationSame){
              return;
            }

            if((localStorage.getItem("cdr") === "true" || localStorage.getItem("cdr") === "false") && !sessionStorage.getItem('location-pre')){
              return;
            }

            ell.classList.add('slidein-from-' + 'right');
          }
        }

    }, [location]);
    
  return null;
}

export default PageTransition